import { SelectionCard } from 'src/app/shared/components/payments';

import { Selection, type Props as SelectionProps } from '../../components/Selection';
import { useSunriseHoldoutExperiment } from '../hooks/useSunriseHoldoutExperiment';

import { Radio } from './Radio';

export function NoSelection({ children, ...selectionProps }: SelectionProps): JSX.Element {
	const { variant, shouldUseBlueCards } = useSunriseHoldoutExperiment();

	const radioProps =
		variant === 'variant_4'
			? {
					Radio: () => {
						return <Radio data-qa={selectionProps.qaSelectorSelection} checked={selectionProps.checked} />;
					},
				}
			: {};

	if (shouldUseBlueCards) {
		return (
			<SelectionCard
				type="text"
				label={selectionProps.label}
				description={selectionProps.message}
				selected={selectionProps.checked}
				onClick={selectionProps.onSelect}
				{...radioProps}
			/>
		);
	}

	return <Selection {...selectionProps}>{children}</Selection>;
}
